import * as React from 'react';

/**
 * Hook that instantiate a [[GridApiRef]].
 */
export const useGridApiRef = () => React.useRef({});


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/utils/useGridApiRef.js
// module id = 2239
// module chunks = 25